import { Outlet } from "react-router";
import Navbar from "../components/navbar/navbar";

const ArtistLayout = () => {
  return (
    <>
      <Navbar hideMenu={true} />
      <div
        className="container"
        style={{ marginTop: "150px", paddingBottom: "5rem" }}
      >
        <Outlet />
      </div>
    </>
  );
};
export default ArtistLayout;
